import {
  createContext,
} from 'react';

const SnowflakeContext = createContext();

export default SnowflakeContext;
